import React, { useState, useEffect } from 'react';
import SantaChatbot from './SantaChatbot';
import SEO from './SEO';
import NewsletterSignup from './NewsletterSignup';
import DailyGame from './DailyGame';
import GameModal from "./GameModal";

const AdventCalendar = () => {
    const [currentDate, setCurrentDate] = useState(new Date());
    const [openedDays, setOpenedDays] = useState(new Set());
    const [snowflakes, setSnowflakes] = useState([]);
    const [selectedGame, setSelectedGame] = useState(null);

    useEffect(() => {
        const timer = setInterval(() => setCurrentDate(new Date()), 1000);
        return () => clearInterval(timer);
    }, []);

    useEffect(() => {
        // Genera fiocchi di neve
        const flakes = Array.from({ length: 80 }, (_, i) => ({
            id: i,
            left: Math.random() * 100,
            animationDuration: 8 + Math.random() * 15,
            animationDelay: Math.random() * 8,
            size: 3 + Math.random() * 5,
            opacity: 0.5 + Math.random() * 0.5
        }));
        setSnowflakes(flakes);
    }, []);

    const adventData = {
        1: {
            gadget: { name: "Tastiera Meccanica RGB", link: "https://www.amazon.it/s?k=tastiera+meccanica+rgb&tag=ideashop0e-21", desc: "Con switch personalizzabili" },
            libro: { name: "Clean Code", author: "Robert C. Martin", link: "https://www.amazon.it/Clean-Code-Handbook-Software-Craftsmanship/dp/0132350882?tag=ideashop0e-21" },
            tool: { name: "GitHub Copilot", desc: "AI pair programming", link: "https://github.com/features/copilot" },
            color: '#dc2626'
        },
        2: {
            gadget: { name: "Mouse Ergonomico Logitech MX", link: "https://www.amazon.it/s?k=logitech+mx+master&tag=ideashop0e-21", desc: "Precisione e comfort" },
            libro: { name: "The Pragmatic Programmer", author: "Hunt & Thomas", link: "https://www.amazon.it/Pragmatic-Programmer-journey-mastery-Anniversary/dp/0135957052?tag=ideashop0e-21" },
            tool: { name: "Cursor", desc: "Editor AI-powered", link: "https://cursor.sh" },
            color: '#16a34a'
        },
        3: {
            gadget: { name: "Webcam 4K Logitech", link: "https://www.amazon.it/s?k=logitech+webcam+4k&tag=ideashop0e-21", desc: "Per meeting professionali" },
            libro: { name: "Design Patterns", author: "Gang of Four", link: "https://www.amazon.it/Design-Patterns-Object-Oriented-Addison-Wesley-Professional/dp/0201633612?tag=ideashop0e-21" },
            tool: { name: "v0.dev", desc: "Generatore UI con AI", link: "https://v0.dev" },
            color: '#2563eb'
        },
        4: {
            gadget: { name: "Monitor 27\" 4K", link: "https://www.amazon.it/s?k=monitor+27+pollici+4k&tag=ideashop0e-21", desc: "IPS con HDR" },
            libro: { name: "Refactoring", author: "Martin Fowler", link: "https://www.amazon.it/Refactoring-Improving-Existing-Addison-Wesley-Signature/dp/0134757599?tag=ideashop0e-21" },
            tool: { name: "Perplexity", desc: "Ricerca potenziata da AI", link: "https://www.perplexity.ai" },
            color: '#dc2626'
        },
        5: {
            gadget: { name: "Auricolari Sony WH-1000XM5", link: "https://www.amazon.it/s?k=sony+wh-1000xm5&tag=ideashop0e-21", desc: "Noise cancelling top" },
            libro: { name: "JavaScript: The Good Parts", author: "Douglas Crockford", link: "https://www.amazon.it/JavaScript-Good-Parts-Douglas-Crockford/dp/0596517742?tag=ideashop0e-21" },
            tool: { name: "Raycast", desc: "Launcher produttivitÃ ", link: "https://www.raycast.com" },
            color: '#a855f7'
        },
        6: {
            gadget: { name: "SSD Esterno 2TB Samsung", link: "https://www.amazon.it/s?k=samsung+ssd+2tb+esterno&tag=ideashop0e-21", desc: "VelocitÃ  e capacitÃ " },
            libro: { name: "You Don't Know JS", author: "Kyle Simpson", link: "https://www.amazon.it/You-Dont-Know-JS-Yet/dp/B084DFZ6GW?tag=ideashop0e-21" },
            tool: { name: "Warp Terminal", desc: "Terminal AI-enhanced", link: "https://www.warp.dev" },
            color: '#16a34a'
        },
        7: {
            gadget: { name: "Lampada da Scrivania LED", link: "https://www.amazon.it/s?k=lampada+scrivania+led+regolabile&tag=ideashop0e-21", desc: "Temperatura colore regolabile" },
            libro: { name: "Eloquent JavaScript", author: "Marijn Haverbeke", link: "https://www.amazon.it/Eloquent-JavaScript-3rd-Introduction-Programming/dp/1593279507?tag=ideashop0e-21" },
            tool: { name: "Pieces", desc: "Snippet manager AI", link: "https://pieces.app" },
            color: '#0891b2'
        },
        8: {
            gadget: { name: "Supporto Laptop Regolabile", link: "https://www.amazon.it/s?k=supporto+laptop+regolabile&tag=ideashop0e-21", desc: "Ergonomia perfetta" },
            libro: { name: "CSS Secrets", author: "Lea Verou", link: "https://www.amazon.it/CSS-Secrets-Solutions-Everyday-Problems/dp/1449372635?tag=ideashop0e-21" },
            tool: { name: "Figma AI", desc: "Design collaborativo", link: "https://www.figma.com" },
            color: '#dc2626'
        },
        9: {
            gadget: { name: "Hub USB-C Multiporta", link: "https://www.amazon.it/s?k=hub+usb-c+multiporta&tag=ideashop0e-21", desc: "7 porte + ricarica" },
            libro: { name: "Learning React", author: "Alex Banks", link: "https://www.amazon.it/Learning-React-Modern-Patterns-Developing/dp/1492051721?tag=ideashop0e-21" },
            tool: { name: "Vercel v0", desc: "Deploy istantaneo", link: "https://vercel.com" },
            color: '#2563eb'
        },
        10: {
            gadget: { name: "Microfono USB Blue Yeti", link: "https://www.amazon.it/s?k=blue+yeti+microfono&tag=ideashop0e-21", desc: "QualitÃ  broadcast" },
            libro: { name: "React Design Patterns", author: "Carlos Santana", link: "https://www.amazon.it/React-Design-Patterns-Best-Practices/dp/1786464535?tag=ideashop0e-21" },
            tool: { name: "Supermaven", desc: "Code completion AI", link: "https://supermaven.com" },
            color: '#16a34a'
        },
        11: {
            gadget: { name: "Sedia Ergonomica Herman Miller", link: "https://www.amazon.it/s?k=sedia+ergonomica+ufficio&tag=ideashop0e-21", desc: "Comfort tutto il giorno" },
            libro: { name: "Don't Make Me Think", author: "Steve Krug", link: "https://www.amazon.it/Dont-Make-Think-Revisited-Usability/dp/0321965515?tag=ideashop0e-21" },
            tool: { name: "Codeium", desc: "Autocomplete gratuito", link: "https://codeium.com" },
            color: '#a855f7'
        },
        12: {
            gadget: { name: "Powerbank 20000mAh Anker", link: "https://www.amazon.it/s?k=anker+powerbank+20000mah&tag=ideashop0e-21", desc: "Ricarica rapida" },
            libro: { name: "Atomic Design", author: "Brad Frost", link: "https://www.amazon.it/Atomic-Design-Brad-Frost/dp/0998296600?tag=ideashop0e-21" },
            tool: { name: "Bolt.new", desc: "Full-stack AI dev", link: "https://bolt.new" },
            color: '#dc2626'
        },
        13: {
            gadget: { name: "Cable Management Kit", link: "https://www.amazon.it/s?k=cable+management+kit&tag=ideashop0e-21", desc: "Scrivania ordinata" },
            libro: { name: "Web Performance in Action", author: "Jeremy Wagner", link: "https://www.amazon.it/Web-Performance-Action-Jeremy-Wagner/dp/1617293377?tag=ideashop0e-21" },
            tool: { name: "Claude", desc: "AI assistant versatile", link: "https://claude.ai" },
            color: '#0891b2'
        },
        14: {
            gadget: { name: "Caricatore Wireless 3-in-1", link: "https://www.amazon.it/s?k=caricatore+wireless+3+in+1&tag=ideashop0e-21", desc: "Phone, Watch, Earbuds" },
            libro: { name: "TypeScript Handbook", author: "Microsoft", link: "https://www.amazon.it/s?k=typescript+handbook&tag=ideashop0e-21" },
            tool: { name: "Tabnine", desc: "AI code assistant", link: "https://www.tabnine.com" },
            color: '#2563eb'
        },
        15: {
            gadget: { name: "Webcam Cover Privacy", link: "https://www.amazon.it/s?k=webcam+cover+privacy&tag=ideashop0e-21", desc: "Sicurezza e privacy" },
            libro: { name: "Frontend Architecture", author: "Micah Godbolt", link: "https://www.amazon.it/Frontend-Architecture-Design-Systems-Sustainable/dp/1491926783?tag=ideashop0e-21" },
            tool: { name: "Resend", desc: "Email API moderna", link: "https://resend.com" },
            color: '#16a34a'
        },
        16: {
            gadget: { name: "Tastierino Numerico Wireless", link: "https://www.amazon.it/s?k=tastierino+numerico+wireless&tag=ideashop0e-21", desc: "Compatto e preciso" },
            libro: { name: "Accessibility Handbook", author: "Katie Cunningham", link: "https://www.amazon.it/Web-Accessibility-Handbook-Katie-Cunningham/dp/1449322859?tag=ideashop0e-21" },
            tool: { name: "Excalidraw", desc: "Diagrammi collaborativi", link: "https://excalidraw.com" },
            color: '#dc2626'
        },
        17: {
            gadget: { name: "Ring Light per Video", link: "https://www.amazon.it/s?k=ring+light&tag=ideashop0e-21", desc: "Luce perfetta" },
            libro: { name: "High Performance Browser", author: "Ilya Grigorik", link: "https://www.amazon.it/High-Performance-Browser-Networking-performance/dp/1449344763?tag=ideashop0e-21" },
            tool: { name: "Linear", desc: "Project management", link: "https://linear.app" },
            color: '#a855f7'
        },
        18: {
            gadget: { name: "Supporto Monitor Doppio", link: "https://www.amazon.it/s?k=supporto+monitor+doppio&tag=ideashop0e-21", desc: "Setup multi-monitor" },
            libro: { name: "SVG Animations", author: "Sarah Drasner", link: "https://www.amazon.it/SVG-Animations-Implementations-Responsive-Animation/dp/1491939702?tag=ideashop0e-21" },
            tool: { name: "Framer", desc: "Design interattivo", link: "https://www.framer.com" },
            color: '#2563eb'
        },
        19: {
            gadget: { name: "Tastiera Programmabile", link: "https://www.amazon.it/s?k=tastiera+programmabile+macro&tag=ideashop0e-21", desc: "Macro personalizzate" },
            libro: { name: "The New CSS Layout", author: "Rachel Andrew", link: "https://www.amazon.it/New-CSS-Layout-Rachel-Andrew/dp/195261631X?tag=ideashop0e-21" },
            tool: { name: "Postman", desc: "API testing", link: "https://www.postman.com" },
            color: '#16a34a'
        },
        20: {
            gadget: { name: "Ventilatore USB Desktop", link: "https://www.amazon.it/s?k=ventilatore+usb+desktop&tag=ideashop0e-21", desc: "Silenzioso ed efficace" },
            libro: { name: "Web Components", author: "Ben Farrell", link: "https://www.amazon.it/Web-Components-Action-Ben-Farrell/dp/1617295779?tag=ideashop0e-21" },
            tool: { name: "Bruno", desc: "API client opensource", link: "https://www.usebruno.com" },
            color: '#0891b2'
        },
        21: {
            gadget: { name: "Poggiapolsi Ergonomico", link: "https://www.amazon.it/s?k=poggiapolsi+ergonomico&tag=ideashop0e-21", desc: "Comfort durante il coding" },
            libro: { name: "System Design Interview", author: "Alex Xu", link: "https://www.amazon.it/System-Design-Interview-insiders-Second/dp/B08CMF2CQF?tag=ideashop0e-21" },
            tool: { name: "Supabase", desc: "Backend as a Service", link: "https://supabase.com" },
            color: '#dc2626'
        },
        22: {
            gadget: { name: "Cavo HDMI 2.1 Certificato", link: "https://www.amazon.it/s?k=cavo+hdmi+2.1&tag=ideashop0e-21", desc: "8K ready" },
            libro: { name: "Designing Data-Intensive", author: "Martin Kleppmann", link: "https://www.amazon.it/Designing-Data-Intensive-Applications-Reliable-Maintainable/dp/1449373321?tag=ideashop0e-21" },
            tool: { name: "Nx", desc: "Monorepo toolkit", link: "https://nx.dev" },
            color: '#2563eb'
        },
        23: {
            gadget: { name: "Pad Ricarica Wireless", link: "https://www.amazon.it/s?k=pad+ricarica+wireless&tag=ideashop0e-21", desc: "Qi certified" },
            libro: { name: "Node.js Design Patterns", author: "Mario Casciaro", link: "https://www.amazon.it/Node-js-Design-Patterns-production-grade-applications/dp/1839214112?tag=ideashop0e-21" },
            tool: { name: "Prisma", desc: "Next-gen ORM", link: "https://www.prisma.io" },
            color: '#16a34a'
        },
        24: {
            gadget: { name: "Organizer da Scrivania", link: "https://www.amazon.it/s?k=organizer+scrivania&tag=ideashop0e-21", desc: "Tutto al suo posto" },
            libro: { name: "Grokking Algorithms", author: "Aditya Bhargava", link: "https://www.amazon.it/Grokking-Algorithms-illustrated-programmers-curious/dp/1617292230?tag=ideashop0e-21" },
            tool: { name: "Turborepo", desc: "High-performance build", link: "https://turbo.build" },
            color: '#a855f7'
        }
    };


    const isDecember = currentDate.getMonth() === 11;
    const currentDay = currentDate.getDate();
    const year = currentDate.getFullYear();

    // Se siamo dopo Natale, calcola per l'anno prossimo
    const targetYear = (isDecember && currentDay > 25) ? year + 1 : year;
    const startDate = new Date(targetYear, 11, 1);
    const christmasDate = new Date(targetYear, 11, 25);

    const daysUntilStart = Math.max(0, Math.floor((startDate - currentDate) / (1000 * 60 * 60 * 24)));
    const daysUntilChristmas = Math.max(0, Math.floor((christmasDate - currentDate) / (1000 * 60 * 60 * 24)));


    const canOpenDay = (day) => {
        return isDecember && currentDay >= day;
    };

    const toggleDay = (day) => {
        if (canOpenDay(day)) {
            setOpenedDays(prev => {
                const newSet = new Set(prev);
                if (newSet.has(day)) {
                    newSet.delete(day);
                } else {
                    newSet.add(day);
                }
                return newSet;
            });
        }
    };

    // Mostra countdown se non è dicembre, o se è dopo Natale (25 dicembre)
    if (!isDecember || currentDay < 1 || currentDay > 25) {
        const now = new Date();
        // Se siamo dopo Natale, il target è il 1° dicembre dell'anno prossimo
        const targetYear = (isDecember && currentDay > 25) ? year + 1 : year;
        const startTarget = new Date(targetYear, 11, 1, 0, 0, 0);
        const diff = (startTarget.getTime() - now.getTime()) - (1000 * 60 * 60);

        const days = Math.max(0, Math.floor(diff / (1000 * 60 * 60 * 24)));
        const hours = Math.max(0, Math.floor((diff / (1000 * 60 * 60)) % 24));
        const minutes = Math.max(0, Math.floor((diff / (1000 * 60)) % 60));
        const seconds = Math.max(0, Math.floor((diff / 1000) % 60));

        return (
            <>
                <SEO />
                <div style={{
                    minHeight: '100vh',
                    background: 'radial-gradient(ellipse at bottom, #0d1b2a 0%, #000 100%)',
                    color: 'white',
                    textAlign: 'center',
                    position: 'relative',
                    overflow: 'hidden',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between'
                }}>
                    <link
                        rel="stylesheet"
                        href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css"
                    />

                    {/* Neve animata */}
                    {snowflakes.map(flake => (
                        <div
                            key={flake.id}
                            style={{
                                position: 'fixed',
                                left: `${flake.left}%`,
                                top: '-20px',
                                width: `${flake.size}px`,
                                height: `${flake.size}px`,
                                background: 'white',
                                borderRadius: '50%',
                                opacity: flake.opacity,
                                animation: `snowfall ${flake.animationDuration}s linear infinite`,
                                animationDelay: `${flake.animationDelay}s`,
                                pointerEvents: 'none',
                                zIndex: 0
                            }}
                        />
                    ))}

                    {/* Luci superiori */}
                    <div style={{
                        position: 'absolute',
                        top: 20,
                        left: 0,
                        right: 0,
                        display: 'flex',
                        justifyContent: 'space-around',
                        zIndex: 10,
                        pointerEvents: 'none'
                    }}>
                        {Array.from({ length: 20 }, (_, i) => {
                            const colors = ['#00fff0', '#ff007f', '#faff00', '#00ff85'];
                            const color = colors[i % colors.length];
                            return (
                                <div
                                    key={i}
                                    style={{
                                        width: 10,
                                        height: 10,
                                        borderRadius: '50%',
                                        background: color,
                                        boxShadow: `0 0 15px ${color}, 0 0 25px ${color}`,
                                        animation: `twinkle ${1 + Math.random() * 2}s ease-in-out infinite`,
                                        animationDelay: `${Math.random() * 2}s`
                                    }}
                                />
                            );
                        })}
                    </div>

                    {/* Hero centrale */}
                    <div style={{
                        flexGrow: 1,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        flexDirection: 'column',
                        padding: '3rem 1rem',
                        zIndex: 5
                    }}>
                        <h1
                            className="appTitle"
                            style={{
                                fontSize: '4rem',
                                fontWeight: '900',
                                background: 'linear-gradient(90deg, rgb(0 233 23), rgb(143 239 104), rgb(31 139 16)) text',
                                WebkitBackgroundClip: 'text',
                                WebkitTextFillColor: 'transparent',
                                textShadow: '0 0 25px rgba(0,255,255,0.3)',
                                marginBottom: '1rem'
                            }}>
                            AdVent Tech
                        </h1>

                        <p style={{
                            fontSize: '1.3rem',
                            color: '#9ca3af',
                            marginBottom: '3rem'
                        }}>
                            Il calendario dell'avvento per sviluppatori, geek e tech lovers
                        </p>

                        <div style={{
                            display: 'flex',
                            justifyContent: 'center',
                            gap: '2rem',
                            flexWrap: 'wrap'
                        }}>
                            <div
                                className='daysToStart'
                                style={{
                                    fontSize: '2rem',
                                    fontWeight: '700',
                                    padding: '1.5rem 2rem',
                                    borderRadius: '1rem',
                                    background: 'rgba(255,255,255,0.05)',
                                    backdropFilter: 'blur(12px)',
                                    boxShadow: '0 0 25px rgba(0,255,180,0.15)',
                                    minWidth: '280px'
                                }}>
                                <i className="fas fa-tree" style={{ color: '#22c55e', marginRight: '0.5rem' }}></i>
                                {daysUntilStart} {daysUntilStart === 1 ? 'giorno' : 'giorni'} al via
                            </div>

                            <div
                                className='daysToChristmas'
                                style={{
                                    fontSize: '2rem',
                                    fontWeight: '700',
                                    padding: '1.5rem 2rem',
                                    borderRadius: '1rem',
                                    background: 'rgba(255,255,255,0.05)',
                                    backdropFilter: 'blur(12px)',
                                    boxShadow: '0 0 25px rgba(255,255,100,0.15)',
                                    minWidth: '280px'
                                }}>
                                <i className="fas fa-gift" style={{ color: 'rgb(219 70 70)', marginRight: '0.5rem' }}></i>
                                {daysUntilChristmas} {daysUntilChristmas === 1 ? 'giorno' : 'giorni'} a Natale
                            </div>
                        </div>

                        <p style={{
                            marginTop: '3rem',
                            color: 'rgb(167 255 78)',
                            fontStyle: 'italic',
                            fontSize: '1.1rem'
                        }}>
                            Preparati a 24 giorni di ispirazione tech, libri e AI tools.
                        </p>

                        {/* Countdown completo */}
                        <div style={{
                            display: 'flex',
                            flexWrap: 'wrap',
                            justifyContent: 'center',
                            alignItems: 'center',
                            gap: '0.4rem',
                            fontSize: '1.2rem',
                            textAlign: 'center',
                            lineHeight: '1.4',
                            color: '#rgb(225 145 145)',
                            maxWidth: '90%',
                            margin: '0 auto',
                            wordBreak: 'break-word'
                        }}>
                            <i className="fas fa-clock" style={{ marginRight: '0.7rem', color: 'rgb(226 76 77)' }}></i>
                            {String(days).padStart(2, '0')}<span style={{ color: '#94a3b8', fontSize: '1rem', margin: '0 0.4rem' }}>giorni</span>
                            {String(hours).padStart(2, '0')}<span style={{ color: '#94a3b8', fontSize: '1rem', margin: '0 0.4rem' }}>ore</span>
                            {String(minutes).padStart(2, '0')}<span style={{ color: '#94a3b8', fontSize: '1rem', margin: '0 0.4rem' }}>minuti</span>
                            {String(seconds).padStart(2, '0')}<span style={{ color: '#94a3b8', fontSize: '1rem', margin: '0 0.4rem' }}>secondi</span>
                        </div>

                        {/* Newsletter signup */}
                        {/*<NewsletterSignup />*/}
                    </div>

                    <SantaChatbot />

                    {/* Footer */}
                    <footer style={{
                        textAlign: 'center',
                        padding: '1.8rem 0',
                        fontSize: '0.9rem',
                        color: '#94a3b8',
                        borderTop: '1px solid rgba(255,255,255,0.1)',
                        background: 'rgba(0,0,0,0.2)',
                        backdropFilter: 'blur(10px)',
                        boxShadow: '0 -5px 20px rgba(0,0,0,0.4)',
                        zIndex: 20
                    }}>
                        <p style={{ margin: 0, fontWeight: 300, marginBottom: '0.6rem' }}>
                            <a href={"https://github.com/zenoproduction"}>
                                <i className="fas fa-code" style={{ color: '#00fff0', marginRight: '6px' }}></i>
                            </a>
                            <a href={"https://www.linkedin.com/in/marco-venturelli-21703448/"} style={{ color: '#00fff0', marginRight: '6px', textDecoration: 'none' }}>in</a>
                            - Creato da <strong style={{ color: '#00ffb0' }}>
                            <a
                                href="https://www.marcoventurelli.com/"
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{ color: '#00ffb0', textDecoration: 'none' }}
                            >
                                MV Software Engineering
                            </a>
                        </strong> - Tutti i diritti riservati Â© {new Date().getFullYear()}
                        </p>
                    </footer>


                    <style>{`
                @keyframes snowfall {
                    0% { transform: translateY(0); opacity: 0; }
                    20% { opacity: 1; }
                    100% { transform: translateY(100vh); opacity: 0; }
                }

                @keyframes twinkle {
                    0%, 100% { opacity: 1; transform: scale(1); }
                    50% { opacity: 0.4; transform: scale(0.8); }
                }
                `}</style>
                </div>
            </>
        );
    }





    return (
        <>
            <SEO />
            <div style={{
                minHeight: '100vh',
                display: 'flex',
                flexDirection: 'column',
                background: 'linear-gradient(135deg, #0f2027 0%, #203a43 50%, #2c5364 100%)',
                padding: '3rem 1.5rem 0',
                position: 'relative',
                overflow: 'hidden'
            }}>
                <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css" />

                {/* Effetto neve */}
                {snowflakes.map(flake => (
                    <div
                        key={flake.id}
                        style={{
                            position: 'absolute',
                            left: `${flake.left}%`,
                            top: '-10px',
                            width: `${flake.size}px`,
                            height: `${flake.size}px`,
                            background: 'white',
                            borderRadius: '50%',
                            opacity: flake.opacity,
                            animation: `snowfall ${flake.animationDuration}s linear infinite`,
                            animationDelay: `${flake.animationDelay}s`,
                            pointerEvents: 'none',
                            boxShadow: '0 0 5px rgba(255,255,255,0.8)'
                        }}
                    />
                ))}

                {/* Luci natalizie */}
                <div style={{
                    position: 'absolute',
                    top: '20px',
                    left: 0,
                    right: 0,
                    display: 'flex',
                    justifyContent: 'space-around',
                    padding: '0 5%',
                    pointerEvents: 'none',
                    zIndex: 10
                }}>
                    {Array.from({ length: 15 }, (_, i) => {
                        const colors = ['#ff0000', '#00ff00', '#0000ff', '#ffff00', '#ff00ff', '#00ffff'];
                        const color = colors[i % colors.length];
                        return (
                            <div
                                key={i}
                                style={{
                                    width: '12px',
                                    height: '12px',
                                    borderRadius: '50%',
                                    background: color,
                                    boxShadow: `0 0 15px ${color}, 0 0 25px ${color}`,
                                    animation: `twinkle ${1 + Math.random() * 2}s ease-in-out infinite`,
                                    animationDelay: `${Math.random() * 2}s`
                                }}
                            />
                        );
                    })}
                </div>

                <div style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    background: 'radial-gradient(circle at 20% 50%, rgba(255,255,255,0.03) 0%, transparent 50%), radial-gradient(circle at 80% 80%, rgba(255,255,255,0.03) 0%, transparent 50%)',
                    pointerEvents: 'none'
                }}></div>

                <div className="container" style={{ maxWidth: '1400px', position: 'relative', zIndex: 1 }}>
                    <div className="text-center mb-5" style={{ marginBottom: '4rem' }}>
                        <div style={{ fontSize: '3rem', marginBottom: '1.2rem' }}>
                            <i
                                className="fas fa-tree"
                                style={{
                                    color: '#22c55e',
                                    filter: 'drop-shadow(0 0 6px #22c55e)',
                                    fontSize: '2.5rem'
                                }}
                            ></i>
                        </div>

                        <h1
                            style={{
                                fontSize: '3rem',
                                fontWeight: '900',
                                color: '#ffffff',
                                textShadow: '0 0 20px rgba(0,255,200,0.3)',
                                letterSpacing: '-0.5px',
                                marginBottom: '0.4rem',
                            }}
                        >
                            Advent Tech
                        </h1>

                        <p
                            style={{
                                color: '#9ca3af',
                                fontSize: '1rem',
                                fontWeight: 300,
                                marginBottom: '1.8rem',
                            }}
                        >
                            Il calendario dell'avvento per sviluppatori, designer e menti creative
                        </p>

                        <div
                            style={{
                                display: 'inline-flex',
                                alignItems: 'center',
                                gap: '0.6rem',
                                background: 'rgba(255,255,255,0.07)',
                                border: '1px solid rgba(255,255,255,0.12)',
                                borderRadius: '1rem',
                                padding: '0.6rem 1.2rem',
                                boxShadow: '0 0 15px rgba(251,191,36,0.2)',
                                color: '#fbbf24',
                                fontWeight: '600',
                                fontSize: '1.05rem',
                                backdropFilter: 'blur(6px)',
                            }}
                        >
                            <i className="fas fa-calendar-alt" style={{ color: '#facc15' }}></i>
                            {daysUntilChristmas > 0
                                ? `${daysUntilChristmas} ${daysUntilChristmas === 1 ? 'giorno' : 'giorni'} a Natale`
                                : (
                                    <>
                                        <i className="fas fa-gift" style={{ marginRight: '0.4rem', color: '#22c55e' }}></i>
                                        Buon Natale!
                                    </>
                                )}
                        </div>
                    </div>


                    <div className="row row-cols-2 row-cols-sm-3 row-cols-md-4 row-cols-lg-6 g-3">
                        {[...Array(24)].map((_, i) => {
                            const day = i + 1;
                            const isOpen = openedDays.has(day);
                            const isAvailable = canOpenDay(day);
                            const data = adventData[day];

                            return (
                                <div key={day} className="col">
                                    <div
                                        style={{
                                            width: '100%',
                                            aspectRatio: '1',
                                            perspective: '1000px',
                                            cursor: isAvailable ? 'pointer' : 'not-allowed'
                                        }}
                                        onClick={() => toggleDay(day)}
                                    >
                                        <div style={{
                                            position: 'relative',
                                            width: '100%',
                                            height: '100%',
                                            transformStyle: 'preserve-3d',
                                            transition: 'transform 0.6s',
                                            transform: isOpen ? 'rotateY(180deg)' : 'rotateY(0deg)'
                                        }}>
                                            {/* Fronte - Numero */}
                                            <div style={{
                                                position: 'absolute',
                                                width: '100%',
                                                height: '100%',
                                                backfaceVisibility: 'hidden',
                                                borderRadius: '1.2rem',
                                                border: '3px solid rgba(255,255,255,0.15)',
                                                background: !isAvailable
                                                    ? 'linear-gradient(135deg, #374151 0%, #1f2937 100%)'
                                                    : `linear-gradient(135deg, ${data.color} 0%, ${data.color}dd 100%)`,
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                fontSize: '2.5rem',
                                                fontWeight: '900',
                                                color: '#fff',
                                                boxShadow: isAvailable
                                                    ? `0 8px 20px ${data.color}50, inset 0 1px 0 rgba(255,255,255,0.1)`
                                                    : '0 4px 10px rgba(0,0,0,0.2)',
                                                opacity: !isAvailable ? 0.5 : 1,
                                                textShadow: '0 2px 8px rgba(0,0,0,0.3)',
                                                transition: 'all 0.3s ease',
                                                overflow: 'hidden'
                                            }}
                                                 onMouseEnter={(e) => {
                                                     if (isAvailable && !isOpen) {
                                                         e.currentTarget.style.transform = 'scale(1.05)';
                                                         e.currentTarget.style.boxShadow = `0 12px 30px ${data.color}60, inset 0 1px 0 rgba(255,255,255,0.2)`;
                                                     }
                                                 }}
                                                 onMouseLeave={(e) => {
                                                     if (!isOpen) {
                                                         e.currentTarget.style.transform = 'scale(1)';
                                                         e.currentTarget.style.boxShadow = isAvailable
                                                             ? `0 8px 20px ${data.color}50, inset 0 1px 0 rgba(255,255,255,0.1)`
                                                             : '0 4px 10px rgba(0,0,0,0.2)';
                                                     }
                                                 }}
                                            >
                                                <div style={{
                                                    position: 'absolute',
                                                    top: 0,
                                                    left: 0,
                                                    right: 0,
                                                    bottom: 0,
                                                    background: 'radial-gradient(circle at 30% 30%, rgba(255,255,255,0.15) 0%, transparent 70%)',
                                                    pointerEvents: 'none'
                                                }}></div>
                                                {day}
                                            </div>

                                            {/* Retro - Contenuto */}
                                            {data && (
                                                <div style={{
                                                    position: 'absolute',
                                                    width: '100%',
                                                    height: '100%',
                                                    backfaceVisibility: 'hidden',
                                                    transform: 'rotateY(180deg)',
                                                    borderRadius: '1.2rem',
                                                    padding: '0.8rem',
                                                    overflow: 'auto',
                                                    background: `radial-gradient(circle at 30% 20%, ${data.color}33, rgba(15,25,35,0.95) 80%)`,
                                                    boxShadow: `inset 0 0 25px ${data.color}22, 0 0 20px ${data.color}33`,
                                                    border: `1.5px solid ${data.color}55`,
                                                    backdropFilter: 'blur(6px)',
                                                    color: '#e2e8f0'
                                                }}>
                                                    <div style={{
                                                        background: 'rgba(17,25,40,0.85)',
                                                        borderRadius: '0.8rem',
                                                        padding: '0.8rem',
                                                        height: '100%',
                                                        display: 'flex',
                                                        flexDirection: 'column',
                                                        justifyContent: 'space-around',
                                                        fontSize: '0.75rem',
                                                        color: '#e5e7eb',
                                                        backdropFilter: 'blur(6px)'
                                                    }}>
                                                        <div>
                                                            <div style={{
                                                                display: 'flex',
                                                                alignItems: 'flex-start',
                                                                gap: '0.4rem',
                                                                marginBottom: '0.3rem'
                                                            }}>
                                                                <i className="fas fa-gift" style={{
                                                                    fontSize: '0.9rem',
                                                                    color: '#dc2626',
                                                                    flexShrink: 0,
                                                                    marginTop: '0.1rem'
                                                                }}></i>
                                                                <div style={{ textAlign: 'left', flex: 1 }}>
                                                                    <a
                                                                        href={data.gadget.link}
                                                                        target="_blank"
                                                                        rel="noopener noreferrer"
                                                                        style={{
                                                                            fontWeight: '700',
                                                                            fontSize: '0.75rem',
                                                                            color: '#dc2626',
                                                                            textDecoration: 'none',
                                                                            display: 'block',
                                                                            lineHeight: '1.2'
                                                                        }}
                                                                        onClick={(e) => e.stopPropagation()}
                                                                        onMouseEnter={(e) => e.currentTarget.style.textDecoration = 'underline'}
                                                                        onMouseLeave={(e) => e.currentTarget.style.textDecoration = 'none'}
                                                                    >
                                                                        {data.gadget.name}
                                                                    </a>
                                                                    <p style={{
                                                                        fontSize: '0.65rem',
                                                                        color: '#e3e3e3',
                                                                        margin: 0,
                                                                        lineHeight: '1.2'
                                                                    }}>
                                                                        {data.gadget.desc}
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div>
                                                            <div style={{
                                                                display: 'flex',
                                                                alignItems: 'flex-start',
                                                                gap: '0.4rem',
                                                                marginBottom: '0.3rem'
                                                            }}>
                                                                <i className="fas fa-book" style={{
                                                                    fontSize: '0.9rem',
                                                                    color: '#2563eb',
                                                                    flexShrink: 0,
                                                                    marginTop: '0.1rem'
                                                                }}></i>
                                                                <div style={{ textAlign: 'left', flex: 1 }}>
                                                                    <a
                                                                        href={data.libro.link}
                                                                        target="_blank"
                                                                        rel="noopener noreferrer"
                                                                        style={{
                                                                            fontWeight: '700',
                                                                            fontSize: '0.75rem',
                                                                            color: '#2563eb',
                                                                            textDecoration: 'none',
                                                                            display: 'block',
                                                                            lineHeight: '1.2',
                                                                            margin: 0
                                                                        }}
                                                                        onClick={(e) => e.stopPropagation()}
                                                                        onMouseEnter={(e) => e.currentTarget.style.textDecoration = 'underline'}
                                                                        onMouseLeave={(e) => e.currentTarget.style.textDecoration = 'none'}
                                                                    >
                                                                        {data.libro.name}
                                                                    </a>
                                                                    <p style={{
                                                                        fontSize: '0.65rem',
                                                                        color: '#e3e3e3',
                                                                        margin: 0,
                                                                        lineHeight: '1.2'
                                                                    }}>
                                                                        {data.libro.author}
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div>
                                                            <div style={{
                                                                display: 'flex',
                                                                alignItems: 'flex-start',
                                                                gap: '0.4rem'
                                                            }}>
                                                                <i className="fas fa-code" style={{
                                                                    fontSize: '0.9rem',
                                                                    color: '#16a34a',
                                                                    flexShrink: 0,
                                                                    marginTop: '0.1rem'
                                                                }}></i>
                                                                <div style={{ textAlign: 'left', flex: 1 }}>
                                                                    <a
                                                                        href={data.tool.link}
                                                                        target="_blank"
                                                                        rel="noopener noreferrer"
                                                                        style={{
                                                                            fontWeight: '700',
                                                                            fontSize: '0.75rem',
                                                                            color: '#16a34a',
                                                                            textDecoration: 'none',
                                                                            display: 'block',
                                                                            lineHeight: '1.2',
                                                                            margin: 0
                                                                        }}
                                                                        onClick={(e) => e.stopPropagation()}
                                                                        onMouseEnter={(e) => e.currentTarget.style.textDecoration = 'underline'}
                                                                        onMouseLeave={(e) => e.currentTarget.style.textDecoration = 'none'}
                                                                    >
                                                                        {data.tool.name}
                                                                    </a>
                                                                    <p style={{
                                                                        fontSize: '0.65rem',
                                                                        color: '#e3e3e3',
                                                                        margin: 0,
                                                                        lineHeight: '1.2'
                                                                    }}>
                                                                        {data.tool.desc}
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        {canOpenDay(day) && (
                                                            <div
                                                                onClick={(e) => { e.stopPropagation(); setSelectedGame(day); }}
                                                                style={{
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    gap: '0.4rem',
                                                                    marginTop: '0.2rem',
                                                                    cursor: 'pointer',
                                                                    paddingTop: '0.2rem',
                                                                    opacity: 0.9,
                                                                    transition: 'all 0.25s ease',
                                                                }}
                                                                onMouseEnter={(e) => {
                                                                    e.currentTarget.style.opacity = '1';
                                                                    e.currentTarget.style.transform = 'scale(1.02)';
                                                                }}
                                                                onMouseLeave={(e) => {
                                                                    e.currentTarget.style.opacity = '0.9';
                                                                    e.currentTarget.style.transform = 'scale(1)';
                                                                }}
                                                            >
                                                                <i
                                                                    className="fas fa-gamepad"
                                                                    style={{
                                                                        fontSize: '0.85rem',
                                                                        color: '#facc15', // giallo ambra fisso
                                                                        flexShrink: 0,
                                                                    }}
                                                                ></i>
                                                                <p
                                                                    style={{
                                                                        fontWeight: '600',
                                                                        fontSize: '0.7rem',
                                                                        color: '#facc15',
                                                                        margin: 0,
                                                                        lineHeight: '1.2',
                                                                        textShadow: '0 0 6px rgba(250,204,21,0.5)'
                                                                    }}
                                                                >
                                                                    Daily Game
                                                                </p>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>

                <SantaChatbot />

                {selectedGame && (
                    <GameModal isOpen={!!selectedGame} onClose={() => setSelectedGame(null)}>
                        <DailyGame day={selectedGame} />
                    </GameModal>
                )}


                {/* Footer */}
                <footer style={{
                    textAlign: 'center',
                    padding: '1.8rem 0',
                    fontSize: '0.9rem',
                    color: '#94a3b8',
                    borderTop: '1px solid rgba(255,255,255,0.1)',
                    zIndex: 20,
                    marginTop: '30px'
                }}>
                    <p style={{ margin: 0, fontWeight: 300, marginBottom: '0.6rem' }}>
                        <a href={"https://github.com/zenoproduction"}>
                            <i className="fas fa-code" style={{ color: '#00fff0', marginRight: '6px' }}></i>
                        </a>
                        <a href={"https://www.linkedin.com/in/marco-venturelli-21703448/"} style={{ color: '#00fff0', marginRight: '6px', textDecoration: 'none' }}>in</a>
                        - Creato da <strong style={{ color: '#00ffb0' }}><a href={"https://www.marcoventurelli.com/"}>MV Software Engineering</a></strong> - Tutti i diritti riservati Â© {new Date().getFullYear()}
                    </p>
                </footer>

                <style>{`
                @keyframes snowfall {
                    0% {
                        transform: translateY(0) translateX(0);
                        opacity: 0;
                    }
                    10% {
                        opacity: 1;
                    }
                    90% {
                        opacity: 1;
                    }
                    100% {
                        transform: translateY(100vh) translateX(100px);
                        opacity: 0;
                    }
                }
                
                @keyframes twinkle {
                    0%, 100% {
                        opacity: 1;
                        transform: scale(1);
                    }
                    50% {
                        opacity: 0.3;
                        transform: scale(0.8);
                    }
                }
            `}</style>


            </div>
        </>
    );
};

export default AdventCalendar;